let prefixoAdmin = "/admin";
const privilegioAdmin = [11];
import auth from "../middleware/auth";

export default [
  {
    path: prefixoAdmin + "/relatorio-questoes",
    name: "relatorio-questoes",
    component: () => import("../pages/admin/relatorioQuestoes/Inicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/mais-saber/relatorio-questoes",
    name: "relatorio-questoes-mais-saber",
    component: () => import("../pages/admin/relatorioQuestoesMaisSaber/Inicio.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/conteudos",
    name: "conteudos",
    component: () => import("../pages/admin/crud/conteudos/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/atividade/adicionar-editar-questao/:id_questao?",
    name: "adicionar-editar-questoes-atividade",
    component: () =>
      import(
        "../pages/admin/relatorioQuestoes/AdicionarEditarQuestaoAtividade.vue"
      ),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/avaliacao/adicionar-editar-questao/:id_questao?",
    name: "adicionar-editar-questoes-avaliacao",
    component: () =>
      import(
        "../pages/admin/relatorioQuestoes/AdicionarEditarQuestaoAvaliacao.vue"
      ),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/mais-saber/avaliacao/adicionar-editar-questao/:id_questao?",
    name: "adicionar-editar-questoes-avaliacao-mais-saber",
    component: () =>
      import(
        "../pages/admin/relatorioQuestoesMaisSaber/AdicionarEditarQuestaoAvaliacao.vue"
      ),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

  //cruds reds

  {
    path: prefixoAdmin + "/crud/saeb",
    name: "Crud-Saeb",
    component: () => import("../pages/admin/crud/saeb/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

  {
    path: prefixoAdmin + "/crud/bncc",
    name: "Crud-BNCC",
    component: () => import("../pages/admin/crud/bncc/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

  {
    path: prefixoAdmin + "/crud/objeto-conhecimento",
    name: "Crud-Objeto-Conhecimento",
    component: () =>
      import("../pages/admin/crud/objetoConhecimento/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

  {
    path: prefixoAdmin + "/crud/habilidade",
    name: "Crud-Conteudo-Aberto",
    component: () => import("../pages/admin/crud/habilidade/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/turmas",
    name: "Crud-Turmas",
    component: () => import("../pages/admin/crud/turmas/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/banner-home",
    name: "Crud-BannerHome",
    component: () => import("../pages/admin/crud/bannerHome/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/podcast",
    name: "Crud-Podcast",
    component: () => import("../pages/admin/crud/podcast/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/audios-ingles",
    name: "Crud-Audio-ingles",
    component: () => import("../pages/admin/crud/audioIngles/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

  {
    path: prefixoAdmin + "/crud/sequencia-didatica",
    name: "Crud-Sequencia-didatica",
    component: () =>
      import("../pages/admin/crud/sequenciaDidatica/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
    props: {
      tipo: "sequencia",
    },
  },
  {
    path: prefixoAdmin + "/crud/planejamentos",
    name: "Crud-Planejamentos",
    component: () =>
      import("../pages/admin/crud/sequenciaDidatica/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
    props: {
      tipo: "planejamento",
    },
  },
  {
    path: prefixoAdmin + "/crud/infograficos-mapas",
    name: "Crud-Infograficos",
    component: () =>
      import("../pages/admin/crud/infograficosMapas/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/videos",
    name: "Crud-Videos",
    component: () => import("../pages/admin/crud/videos/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

  {
    path: prefixoAdmin + "/crud/videoaulas-animacoes",
    name: "Crud-Videoaulas",
    component: () =>
      import("../pages/admin/crud/videoaulasAnimacoes/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/projetos-integradores",
    name: "Crud-Projetos-Integradores",
    component: () =>
      import("../pages/admin/crud/sequenciaDidatica/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
    props: {
      tipo: "projeto_integrador",
    },
  },

  {
    path: prefixoAdmin + "/crud/audios-ingles",
    name: "Crud-Audios-Ingles",
    component: () => import("../pages/admin/crud/podcast/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
    props: {
      tipo: "audio_ingles",
    },
  },
  {
    path: prefixoAdmin + "/crud/livros",
    name: "Crud-Livros",
    component: () => import("../pages/admin/crud/livro/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/conteudo-aberto",
    name: "Conteudo-Aberto",
    component: () => import("../pages/admin/conteudoAberto/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/conteudo-aberto/adicionar-editar-conteudo",
    name: "Adicionar-Editar-conteudo",
    component: () =>
      import("../pages/admin/conteudoAberto/AdicionarEditarArtigo.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/obras",
    name: "Crud-Obras",
    component: () => import("../pages/admin/crud/obra/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/disciplinas",
    name: "Crud-Disciplinas",
    component: () => import("../pages/admin/crud/disciplina/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/escolas",
    name: "Crud-Escolas",
    component: () => import("../pages/admin/crud/escola/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/municipios",
    name: "Crud-Municipio",
    component: () => import("../pages/admin/crud/municipio/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/contratos",
    name: "Crud-Contratos",
    component: () => import("../pages/admin/crud/contrato/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/crud/usuarios",
    name: "Crud-Usuarios",
    component: () =>
      import("../pages/admin/crud/usuario/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },
  {
    path: prefixoAdmin + "/pnld",
    name: "Crud-Usuarios",
    component: () =>
      import("../pages/admin/crud/pnldCompartilhamento/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

  //cruds assessoria

  {
    path: prefixoAdmin + "/crud/encontros-pedagogicos",
    name: "Crud-Encontros-Pedagogicos",
    component: () =>
      import("../pages/admin/crud/encontrosPedagogicos/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
    props: {
      tipo: "encontro",
    },
  },
  {
    path: prefixoAdmin + "/crud/informacoes",
    name: "Crud-Informacoes",
    component: () => import("../pages/admin/crud/informacoes/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
    props: {
      tipo: "informacao",
    },
  },
  {
    path: prefixoAdmin + "/crud/conteudo-apoio",
    name: "Crud-Conteudo-Apoio",
    component: () => import("../pages/admin/crud/conteudoApoio/Home.vue"),
    beforeEnter: auth,
    meta: {
      id_privilegio: privilegioAdmin,
    },
  },

	{
		path: prefixoAdmin + "/crud/marketing-educacional",
		name: "Crud-Marketing-Educacional",
		component: () => import("../pages/admin/crud/marketingEducacional/Home.vue"),
		beforeEnter: auth,
		meta: {
			id_privilegio: privilegioAdmin,
		},
	},

	{
		path: prefixoAdmin + "/relatorios/questao-habilidade",
		name: "Relatorio-Questao-Habilidade",
		component: () => import("../pages/admin/relatorios/questaoHabilidade/HomeView.vue"),
		beforeEnter: auth,
		meta: {
			id_privilegio: privilegioAdmin,
		},
	},
	{
		path: prefixoAdmin + "/relatorios/questao-habilidade/atividade",
		name: "Relatorio-Questao-Habilidade-Atividade",
		component: () => import("../pages/admin/relatorios/questaoHabilidade/atividade/HomeView.vue"),
		beforeEnter: auth,
		meta: {
			id_privilegio: privilegioAdmin,
		},
	},
	{
		path: prefixoAdmin + "/relatorios/questao-habilidade/avaliacao",
		name: "Relatorio-Questao-Habilidade-Avaliacao",
		component: () => import("../pages/admin/relatorios/questaoHabilidade/avaliacao/HomeView.vue"),
		beforeEnter: auth,
		meta: {
			id_privilegio: privilegioAdmin,
		},
	},
];
